import React from "react";
import Locale from "../../../locale/Locale";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';

export default class HistoryTimeRange extends React.Component {

    render(props) {
        return (
            <div style={{ marginBottom: 20 }}>
                <div key="timeRangeSelector" className="col-md-4 pull-left">
                    <Form.Select 
                        size="sm" 
                        value={ this.props.valueHours } 
                        onChange={(e) => 
                            this.props.onChange({ valueHours: e.target.value})
                        }
                    >
                        <option value="3">last 3 hours</option>
                        <option value="6">last 6 hours</option>
                        <option value="12">last 12 hours</option>
                        <option value="24">last 24 hours</option>
                        <option value="72">last 72 hours</option>
                        <option value="168">last 168 hours</option>
                        <option value="336">Two weeks</option>
                        <option value="672">Four weeks</option>
                    </Form.Select>
                </div>
            </div>
        );
    }
}